import React from 'react'
import clsx from 'clsx'
import {Typography} from '../components/Typography'

const BreadcrumbText = ({active, children, ...others}) => {
  const styleText = clsx('uppercase', active && 'underline')

  return (
    <Typography as="span" color={active && 'blue-500'} className={styleText} {...others}>
      {children}
    </Typography>
  )
}

const BreadcrumbItem = ({children, ...others}) => {
  return (
    <div {...others}>
      {children}
    </div>
  )
}

const BreadcrumbLink = ({active, children, ...others}) => {
  const styleText = clsx('uppercase', active && 'underline')

  return (
    <a href="/" {...others}>
      <Typography as="span" color={active && 'blue-500'} className={styleText}>
        {children}
      </Typography>
    </a>
  )
}

const Breadcrumbs = ({children, ...others}) => {
  return (
    <div {...others}>
      {children}
    </div>
  )
}

export {Breadcrumbs, BreadcrumbText, BreadcrumbLink, BreadcrumbItem}
